module.exports = "/packs/media/images/module-savings-0ed07f2dda4b7e9f6a24db115ea642f5.png";